import * as React from 'react';
const NCoinsIcon = () => {
	return (
		<svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<g clipPath='url(#clip0_3262_655)'>
				<path
					d='M10 19.7795C15.4011 19.7795 19.7795 15.4011 19.7795 9.99998C19.7795 4.5989 15.4011 0.220459 10 0.220459C4.59892 0.220459 0.220478 4.5989 0.220478 9.99998C0.220478 15.4011 4.59892 19.7795 10 19.7795Z'
					fill='#FF9900'
				/>
				<path
					d='M10 19.7795C15.4011 19.7795 19.7795 15.4011 19.7795 9.99998C19.7795 4.5989 15.4011 0.220459 10 0.220459C4.59892 0.220459 0.220478 4.5989 0.220478 9.99998C0.220478 15.4011 4.59892 19.7795 10 19.7795Z'
					fill='#FF9900'
				/>
				<path
					d='M10 19.7795C15.4011 19.7795 19.7795 15.4011 19.7795 9.99998C19.7795 4.5989 15.4011 0.220459 10 0.220459C4.59892 0.220459 0.220478 4.5989 0.220478 9.99998C0.220478 15.4011 4.59892 19.7795 10 19.7795Z'
					fill='url(#paint0_linear_3262_655)'
				/>
				<path
					d='M10 18.5197C14.7053 18.5197 18.5197 14.7053 18.5197 9.99999C18.5197 5.29469 14.7053 1.48029 10 1.48029C5.2947 1.48029 1.4803 5.29469 1.4803 9.99999C1.4803 14.7053 5.2947 18.5197 10 18.5197Z'
					fill='url(#paint1_linear_3262_655)'
				/>
				<path
					opacity='0.64'
					d='M9.99999 1.48029C14.7053 1.48029 18.5197 5.2947 18.5197 9.99999C18.5197 14.7053 14.7053 18.5197 9.99999 18.5197C5.2947 18.5197 1.48029 14.7053 1.48029 9.99999C1.48029 5.2947 5.2947 1.48029 9.99999 1.48029ZM9.99999 1.32281C8.82863 1.32281 7.69226 1.55227 6.62238 2.00477C5.58909 2.4418 4.66112 3.06743 3.8643 3.8643C3.06743 4.66116 2.4418 5.58909 2.00477 6.62238C1.55223 7.69226 1.32281 8.82863 1.32281 9.99999C1.32281 11.1714 1.55227 12.3077 2.00477 13.3776C2.4418 14.4109 3.06743 15.3389 3.8643 16.1357C4.66116 16.9325 5.58909 17.5582 6.62238 17.9952C7.69226 18.4478 8.82863 18.6772 9.99999 18.6772C11.1714 18.6772 12.3077 18.4477 13.3776 17.9952C14.4109 17.5582 15.3389 16.9326 16.1357 16.1357C16.9326 15.3388 17.5582 14.4109 17.9952 13.3776C18.4478 12.3077 18.6772 11.1714 18.6772 9.99999C18.6772 8.82863 18.4477 7.69226 17.9952 6.62238C17.5582 5.58909 16.9326 4.66112 16.1357 3.8643C15.3388 3.06743 14.4109 2.4418 13.3776 2.00477C12.3077 1.55223 11.1714 1.32281 9.99999 1.32281Z'
					fill='url(#paint2_linear_3262_655)'
				/>
				<path
					d='M10 0.220477C15.4011 0.220477 19.7795 4.59891 19.7795 10C19.7795 15.4011 15.4011 19.7795 10 19.7795C4.59891 19.7795 0.220477 15.4011 0.220477 10C0.220477 4.59891 4.59891 0.220477 10 0.220477ZM10 0C8.65011 0 7.34047 0.264441 6.10747 0.785947C4.91667 1.28961 3.84724 2.01062 2.92891 2.92895C2.01058 3.84729 1.28961 4.91667 0.785905 6.10752C0.264441 7.34047 0 8.65011 0 10C0 11.3499 0.264441 12.6595 0.785946 13.8925C1.28961 15.0833 2.01062 16.1528 2.92895 17.0711C3.84729 17.9894 4.91667 18.7104 6.10751 19.2141C7.34051 19.7356 8.65015 20 10 20C11.3499 20 12.6596 19.7356 13.8926 19.2141C15.0834 18.7104 16.1528 17.9894 17.0711 17.0711C17.9895 16.1528 18.7104 15.0834 19.2141 13.8925C19.7356 12.6595 20.0001 11.3499 20.0001 10C20.0001 8.65011 19.7356 7.34047 19.2141 6.10747C18.7105 4.91667 17.9895 3.84724 17.0711 2.92891C16.1528 2.01058 15.0834 1.28961 13.8926 0.785905C12.6595 0.264441 11.3499 0 10 0Z'
					fill='url(#paint3_linear_3262_655)'
				/>
				<path
					d='M10 18.0945C14.4705 18.0945 18.0945 14.4705 18.0945 10C18.0945 5.52954 14.4705 1.90552 10 1.90552C5.52954 1.90552 1.90552 5.52954 1.90552 10C1.90552 14.4705 5.52954 18.0945 10 18.0945Z'
					fill='#FFCC33'
				/>
				<path
					opacity='0.08'
					d='M16.1915 6.4125C16.2242 6.28634 16.4724 5.11815 16.4724 5.11815C16.4724 5.11815 16.7473 4.75029 16.811 4.60633C16.8631 4.34951 16.9073 4.05355 16.9291 3.72442C16.9523 3.37547 16.9455 3.05969 16.9249 2.78614C16.0398 1.93576 15.0208 1.26316 13.8925 0.785947C12.6595 0.264441 11.3499 0 10 0C8.65011 0 7.34047 0.264441 6.10747 0.785947C4.91667 1.28961 3.84724 2.01062 2.92891 2.92895C2.01058 3.84729 1.28961 4.91667 0.785905 6.10752C0.264441 7.34047 0 8.65011 0 10C0 11.3499 0.264441 12.6595 0.785947 13.8925C1.02719 14.4629 1.31882 15.005 1.6576 15.5165C1.93852 15.5859 2.29805 15.6458 2.71651 15.6457C2.96851 15.6456 3.19587 15.6238 3.39311 15.593L3.8189 15.2205C4.71877 15.298 5.91452 15.3074 7.28617 15.0553C7.33334 15.0466 7.38019 15.0377 7.42679 15.0286C9.69296 14.586 11.7055 13.2974 13.0853 11.446C13.7413 10.5658 14.4965 9.52266 15.1275 8.57145C15.6556 7.77529 15.9921 7.18378 16.1915 6.41246L16.1915 6.4125Z'
					fill='white'
				/>
				<path
					d='M9.53094 4.93439C9.69218 4.91916 9.85593 4.91193 10.0212 4.91193C10.2311 4.91194 10.438 4.92556 10.6413 4.95001V3.6629H11.7507V5.2088C13.6935 5.90256 15.0846 7.73109 15.0847 9.87091V14.8309H12.7468V9.87091C12.7467 9.04116 12.3587 8.29865 11.7507 7.80841V8.93439H10.6413V7.27228C10.4419 7.22662 10.2346 7.20004 10.0212 7.20001C9.85388 7.20001 9.68999 7.21655 9.53094 7.24493V8.93439H8.42157V7.71173C7.73951 8.19768 7.29368 8.98362 7.29364 9.87091V14.8309H4.95673V9.87091C4.95678 7.68357 6.41064 5.8231 8.42157 5.16583V3.6629H9.53094V4.93439Z'
					fill='#2D2D2D'
				/>
			</g>
			<defs>
				<linearGradient
					id='paint0_linear_3262_655'
					x1='-3.50163'
					y1='-2.23717'
					x2='17.3488'
					y2='16.6605'
					gradientUnits='userSpaceOnUse'
				>
					<stop stopColor='#FFCC33' />
					<stop offset='1' stopColor='#FF9900' />
				</linearGradient>
				<linearGradient
					id='paint1_linear_3262_655'
					x1='1.4803'
					y1='9.99999'
					x2='18.5197'
					y2='9.99999'
					gradientUnits='userSpaceOnUse'
				>
					<stop stopColor='#FF9900' />
					<stop offset='1' stopColor='#FFE33D' />
				</linearGradient>
				<linearGradient
					id='paint2_linear_3262_655'
					x1='1.32281'
					y1='9.99999'
					x2='18.6772'
					y2='9.99999'
					gradientUnits='userSpaceOnUse'
				>
					<stop stopColor='#905024' />
					<stop offset='1' stopColor='#E77E1A' />
				</linearGradient>
				<linearGradient id='paint3_linear_3262_655' x1='0' y1='10' x2='20' y2='10' gradientUnits='userSpaceOnUse'>
					<stop stopColor='#FFE54A' />
					<stop offset='1' stopColor='#FFB000' />
				</linearGradient>
				<clipPath id='clip0_3262_655'>
					<rect width='20' height='20' fill='white' />
				</clipPath>
			</defs>
		</svg>
	);
};

export default NCoinsIcon;
